
import React, { useEffect, useState } from 'react';
import { Button, Dialog, Divider, Form, Input, Message } from '@alifd/next';
import CacheUtils from '@/utils/CacheUtils';
import styles from './index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import { Servlets } from '@/service';
import GIFT from '@/assets/gift.svg';
let timer = 0;
const CacheCodeKey = 'INDEX_SMS_CODE_TIK';
function SavePhoneNumber(props) {
  const {dialogVisible, setDialogVisible} = props;

  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState<string | undefined>(undefined);
  const [countdown, setCountdown] = useState(+(CacheUtils.getItem(CacheCodeKey) || 0));
  const tik = (val: number) => {
    const count = val;
    if (timer) {
      window.clearTimeout(timer);
      timer = 0;
    }
    if (count > 0) {
      setCountdown(count - 1);
      CacheUtils.setItem(CacheCodeKey, count - 1);
      timer = window.setTimeout(() => {
        tik(count - 1);
      }, 1000);
    } else {
      setCountdown(0);
      window.clearTimeout(timer);
      timer = 0;
      CacheUtils.setItem(CacheCodeKey, 0);
    }
  };
  const handleSendCode = async () => {
    try {
      tik(60);
      Servlets('setMobileSmsCode', {phoneNumber:mobile}).then((res:{success,data,resp_msg}) =>
      {
        if (res.success) {
          LzMsg.success(`验证码发送到号码为${mobile}手机`);
        }else {
          LzMsg.error(res.resp_msg);
        }
      }).catch((e) => {
        console.log(e);
        LzMsg.error(e.message);
      });
    } catch (e) {
      tik(0);
      Message.error(`验证码获取失败`);
    }
  };
  const handleSubmit = async (values, errors) => {
    if (errors) {
      return;
    }
    try {
      Servlets('savePhoneNumber', {...values,activityId:'1'}).then((res:{success,data,resp_msg}) =>
      {
        if (res.success) {
          LzMsg.success('手机号码保存成功');
          setDialogVisible(false);
        }else {
          LzMsg.error(res.resp_msg);
        }
      }).catch((e) => {
        console.log(e);
        LzMsg.error(e.message);
      });
      // userAction.setState({ mobile });
      setLoading(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // if (!currentUser.mobile && +currentUser.accountType !== 3) {
      if(CacheUtils.getItem(CacheCodeKey)) { // 页面刷新后继续计时
        tik(+(CacheUtils.getItem(CacheCodeKey) || 0))
      }
      setDialogVisible(true)
    // }
  }, []);
  return (
    <Dialog
      visible={dialogVisible}
      title={false}
      centered
      animation={{ in: 'zoomIn', out: 'zoomOut' }}
      closeable={false}
      closeIcon={false}
      footer={false}
    >
      <div className={styles.FirstOpen}>
        <h2>为了更好的使用体验，请完善以下信息</h2>
        <div className={styles.Gift}>
          <img src={GIFT} alt="gift" width={32} />
          <div className={styles.giftDesc}>
            完善信息，立享1000条短信礼包！
          </div>
        </div>
        <Form className={styles.LoginFormPanel} size={'medium'}>
          <Form.Item
            name="phoneNumber"
            pattern={/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/}
            patternMessage={'请输入正确的手机号码'}
          >
            <Input
              maxLength={11}
              value={mobile}
              onChange={setMobile}
              hasClear
              autoComplete={'off'}
              placeholder={'手机号码'}
            />
          </Form.Item>
          <Form.Item name="code">
            <Input
              addonAfter={
                <Button
                  onClick={handleSendCode}
                  className={styles.SmsCodeButton}
                  disabled={!mobile.match(/1[3456789]\d{9}/) || countdown > 0}
                  style={{height:'32px'}}
                >
                  {countdown ? `${countdown}秒重发` : '获取验证码'}
                </Button>
              }
              value={code}
              onChange={setCode}
              maxLength={6}
              style={{ width: '100%' }}
              placeholder="验证码"
            />
          </Form.Item>
          <Form.Item>
            <Form.Submit
              type={'primary'}
              disabled={!(mobile && code)}
              onClick={handleSubmit}
              loading={loading}
              className={styles.SubmitButton}
            >
              提交
            </Form.Submit>
          </Form.Item>
        </Form>
        <Divider />
        <div className={styles.PageDesc}>
          <div className={styles.partOne}>
            <div>特别说明：</div>
            <div>绑定手机号仅用于以下服务</div>
          </div>
          <ol>
            <li>日常运营策略支持；</li>
            <li>大促活动消息；</li>
            <li>CRM运营咨询；</li>
            <li>代运营能力支持；</li>
            <li>运营策划、实施、落地、数据分析、运营报告</li>
          </ol>
          <div className={styles.partTwo}>我们不会向任何第三方或者机构提供您的手机号码</div>
          <div>短信礼包每店铺只能领取一次。</div>
        </div>
      </div>
    </Dialog>
  );
}

export default SavePhoneNumber;
